import axios from 'axios';
import env from '@/config/env.example.js';

const request=axios.create({
    baseURL:env.server,
});
const isHandlerEnabled=(config={})=>{
    return config.hasOwnProperty('handlerEnabled')&&!config.handlerEnabled?false:true;
};

request.defaults.timeout=2500;
request.interceptors.request.use(
    config=>{
        var token=localStorage.getItem('tok')||null;
        var user=JSON.parse(localStorage.getItem('iden'))||null;
        config.headers["X-Access-Token"]=token;
        config.headers["X-Access-Id"]=user!=null?user._id:null;
        return config;
    },
    error=>{
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    response=>{
        if(response.status!==200){
            return Promise.reject(response.message);
        }
        return response;
    },
    error=>{
        return Promise.reject(error)
    }
);
export default request;